<template>
  <b-card class="mb-5">
    <b-row>
      <b-col md="6">
        <h3>{{ $route.name }}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
      </b-col>
      <b-col md="6 mt-4 float-right">
        <b-button variant="primary" class="float-right btn-custom" :to="'quotation/create'"
          ><font-awesome-icon icon="plus"
        /></b-button>
        <!-- <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToExcel()" variant="info" class="mr-1 float-right btn-custom"><font-awesome-icon icon="download"/></b-button> -->
      </b-col>
    </b-row>
    <div class="border-bottom mb-1"></div>
    <b-row class="mt-3">
      <b-col md="4">
        <b-form-input
          v-model="tableFilter.quotation_id"
          v-on:afterHit="doFilter"
          customQueryParamName="search"
          placeholder="Quotation No."
        />
      </b-col>
      <b-col md="4">
        <!-- <b-form-select v-model="tableFilter.statusQuotation" :options="statusList" />  -->
        <b-form-input
          v-model="tableFilter.search_customer"
          v-on:afterHit="doFilter"
          customQueryParamName="search"
          placeholder="Quotation To"
        />
      </b-col>
      <b-col md="3">
        <!-- button filter -->
        <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search">
          <font-awesome-icon icon="search" />Filter
        </button>
        <!-- end button -->

        <!-- button clear filter -->
        <button
          @click="clearFilter()"
          class="ml-0 btn btn-outline-primary float-right"
          id="btn-search"
        >
          <font-awesome-icon icon="times-circle" /> Clear Filter
        </button>
        <!-- end button -->
      </b-col>
      <b-button
        variant="light"
        style="margin-left:-65px!important; padding-bottom:10px!important;"
        disabled
        ><font-awesome-icon icon="spinner" spin v-if="isLoadingBranch" />
      </b-button>
    </b-row>
    <b-row> </b-row>
    <b-row class="mt-3 mb-3">
      <b-col md="4"> </b-col>
      <b-col md="4">
        <!-- <b-form-select v-model="tableFilter.order_type_id" :options="orderTypeList" />   -->
      </b-col>
    </b-row>
    <paginated-table
      ref="dataTable"
      :can-delete="true"
      :can-reject="false"
      :can-approve="false"
      :can-show="true"
      :can-edit="true"
      :data-url="apiUrl.quotation"
      :data-key="dataKey"
      :data-columns="columns"
      :data-params="['quotation_id', 'start_date', 'end_date', 'search_customer']"
    >
    </paginated-table>
  </b-card>
</template>
<script>
import PaginatedTable from '@/components/PaginatedTable';
// import DatePicker from 'vue2-datepicker'
// import 'vue2-datepicker/index.css'
export default {
  name: 'sales-order',
  components: {
    PaginatedTable,
    // DatePicker
  },
  data() {
    return {
      isLoadingBranch: false,
      dataKey: 'quotation',
      apiUrl: {
        quotation: window.AppConfig.apiUrl + 'quotation',
        exportQuotation: window.AppConfig.apiUrl + 'export-quotation-general',
      },
      columns: [
        {
          key: 'quotationId',
          label: 'Quotation No.',
          sortable: true,
        },
        
        {
          key: 'customer',
          label: 'Quotation To',
          sortable: true,
        },

        {
          key: 'referenceTitle',
          label: 'Subject',
        },

        {
          key: 'actions',
          label: '',
        },
      ],
      orderTypeList: [
        {
          value: null,
          text: 'Order Type',
        },
        {
          value: 'Application',
          text: 'Application',
        },
        {
          value: 'Maintenance',
          text: 'Maintenance',
        },
        {
          value: 'Sales',
          text: 'Sales',
        },
        {
          value: 'Services',
          text: 'Services',
        },
        {
          value: 'Other',
          text: 'Other',
        },
      ],
      companyList: [
        {
          value: null,
          text: 'Company',
        },
      ],
      branchList: [
        {
          value: null,
          text: 'Branch',
        },
      ],
      statusList: [
        {
          value: null,
          text: 'Status',
        },
        {
          value: 'Issued',
          text: 'Issued',
        },
        {
          value: 'Approved',
          text: 'Approved',
        },
        {
          value: 'Rejected',
          text: 'Rejected',
        },
      ],
      tableFilter: {
        quotation_id: this.$route.query.quotation_id,
        status: this.$route.query.status,
        statusQuotation: null,
        order_type: this.$route.query.order_type,
        order_type_id: null,
        company_uuid: this.$route.query.company,
        company: null,
        branch_uuid: this.$route.query.branch,
        branch: null,
        search_customer: this.$route.query.search_customer,
        date: null,
        start_date: this.$route.query.start_date,
        end_date: this.$route.query.end_date,
      },
    };
  },
  watch: {
    'tableFilter.company'(value) {
      this.getBranch(value);
    },
    'tableFilter.branch'() {
      this.doFilter();
    },
    'tableFilter.quotation_id'() {
      this.doFilter();
    },
    'tableFilter.statusQuotation'() {
      this.doFilter();
    },
    'tableFilter.search_customer'() {
      this.doFilter();
    },
    'tableFilter.order_type_id'() {
      this.doFilter();
    },
    'tableFilter.date'(value) {
      if (value !== null && value.length >= 1 && value[0] === null && value[1] === null) {
        this.tableFilter.date = null;
        this.doFilter();
      } else {
        this.doFilter();
      }
    },
  },
  mounted() {
    this.getCompany();
  },
  methods: {
    doFilter() {
      this.tableFilter.quotation_id = this.tableFilter.quotation_id;
      this.tableFilter.status = this.tableFilter.statusQuotation;
      this.tableFilter.order_type = this.tableFilter.order_type_id;
      this.tableFilter.search_customer = this.tableFilter.search_customer;
      this.tableFilter.company_uuid = this.tableFilter.company;
      this.tableFilter.branch_uuid = this.tableFilter.branch;
      this.tableFilter.start_date =
        this.tableFilter.date !== null
          ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD')
          : null;
      this.tableFilter.end_date =
        this.tableFilter.date !== null
          ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD')
          : null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },
    doExportToExcel() {
      let url =
        this.apiUrl.exportQuotation +
        '?token=' +
        this.$store.getters['account/tokens'].access_token;
      if (this.tableFilter.quotation_id !== undefined && this.tableFilter.quotation_id !== null) {
        url += '&quotation_id=' + this.tableFilter.quotation_id;
      }
      if (
        this.tableFilter.search_customer !== undefined &&
        this.tableFilter.search_customer !== null
      ) {
        url += '&search_customer=' + this.tableFilter.search_customer;
      }
      if (this.tableFilter.order_type !== undefined && this.tableFilter.order_type !== null) {
        url += '&order_type=' + this.tableFilter.order_type;
      }
      if (this.tableFilter.company_uuid !== undefined && this.tableFilter.company_uuid !== null) {
        url += '&company_uuid=' + this.tableFilter.company_uuid;
      }
      if (this.tableFilter.branch_uuid !== undefined && this.tableFilter.branch_uuid !== null) {
        url += '&branch_uuid=' + this.tableFilter.branch_uuid;
      }
      if (this.tableFilter.status !== undefined && this.tableFilter.status !== null) {
        url += '&status=' + this.tableFilter.status;
      }
      if (this.tableFilter.date !== null) {
        url +=
          '&start_date=' +
          this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') +
          '&end_date=' +
          this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD');
      }
      window.open(url);
    },
    getCompany() {
      this.$http.get(window.AppConfig.apiUrl + 'company').then((response) => {
        response.data._embedded.company.forEach((data) => {
          this.companyList.push({
            value: data.uuid,
            text: data.name,
          });
        });
      });
    },
    getBranch(companyUuid = null) {
      this.isLoadingBranch = true;
      if (companyUuid != null && this.tableFilter.company != null) {
        this.doFilter();
        this.tableFilter.branch_uuid = this.tableFilter.branch;
        this.tableFilter.branch = null;
        this.tableFilter.company_uuid = this.tableFilter.company;
      } else {
        this.doFilter();
        this.tableFilter.branch = null;
        this.tableFilter.company = null;
      }
      this.$http
        .get(
          window.AppConfig.apiUrl + 'branch?limit=100&company_uuid=' + companyUuid + '&is_active=1',
        )
        .then((response) => {
          this.branchList = [];
          this.isLoadingBranch = false;
          response.data._embedded.branch.forEach((data) => {
            this.branchList.push({
              value: data.uuid,
              text: data.name,
            });
          });
        })
        .catch((error) => {
          window.consoleLog(error);
          this.isLoadingBranch = false;
        });
    },
    getStatusColor(val) {
      switch (val) {
        case 'Issued':
          return 'primary';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
    clearFilter(){
      this.tableFilter.quotation_id = null;
      this.tableFilter.search_customer = null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    }
  },
};
</script>
